import { React, useContext } from 'react'
import f_payment from ".././assets/images/Failed.svg"

const PaymentFailed = () => {
    return (
        <>
            <div className="innerMainImg">
                <img src={f_payment} alt="" />
            </div>

        </>
    )
}

export default PaymentFailed;
